import { USER_FORM, Roles } from '../form-portaluser-type';
import { displayUserAccessArea } from '../user-access/display-user-access';
import { displaySelectedValue } from '../../../dropdown';
import { displayLinkedPartnerCustomer } from '../../../widgets/partner-customer-widget';

import { IUser, IWpUser, IAccessList } from '../../../../models/user.interface';
import { showToast } from '../../../toasts';

/**
 * Parses and displays existing portal user data on the portal user form page.
 * 
 * @param {IWpUser} wpData the WordPress user data
 * @param {IUser} awsData the AWS user data
 * 
 * @return void
 */
const DisplayExistingPortalUser = ({ userName, userFirstName, userLastName, userEmail, userStatus, userRole, lastLogin }: IWpUser, awsData: IUser) => {
  const { accessLevel } = awsData.body;

  USER_FORM.userName.value = userName;
  USER_FORM.userLastLogin.value = lastLogin;  
  USER_FORM.userFirstName.value = userFirstName;
  USER_FORM.userLastName.value = userLastName;
  USER_FORM.userEmail.value = userEmail;

  if ( userRole[0] === null ) showToast('aafp_toast-alert', 'User role not found. Please assign one.');

  displayUserAccessArea(userRole[0]);

  const userType = USER_FORM.userRole;
  const observer = new MutationObserver((mutRecords: any) => {
    for (const { type, attributeName, target } of mutRecords) {
      if(type !== 'attributes' || attributeName !== 'data-value') {
        return;
      }

      if(target.getAttribute('data-value')) {
        const newUserRole = userType.getAttribute('data-value') as Roles;
        if (newUserRole !== userRole[0]) {
          displayUserAccessArea(newUserRole); 
        }                
      }
    }
  });
  observer.observe(userType, { attributes: true });

  if ( accessLevel != 'A' ) {
    const list: IAccessList[] = Array.from(Object.values(awsData.body.accessList), (value: IAccessList) => ({
      id: value.id,
      name: value.name,
    }));

    const linkedListCon = document.querySelector<HTMLElement>('.linked-list');

    linkedListCon && displayLinkedPartnerCustomer(linkedListCon!, list);
  }
  
  displaySelectedValue('.aafp_list-status', 'status', userStatus);
  displaySelectedValue('.aafp_list-role', 'role', userRole[0]);
}

export default DisplayExistingPortalUser;